import { createContext, useReducer } from 'react';

export const SearchContext = createContext();

const initialState = {
    byCURP: { curp: "" },
    byForm: {
        nombre: "",
        apellido: "",
        fechaNacimiento: null,
        estadoNacimiento: 0,
    },
    searchType: null,
};

const reducer = (state, action) => {
    switch (action.type) {
        case "SET_SEARCH":
            sessionStorage.setItem("searchParams", JSON.stringify(action.payload));
            return action.payload;
        case "CLEAR_SEARCH":
            sessionStorage.removeItem("searchParams");
            return initialState;
        default:
            return state;
    }
};

const savedState = sessionStorage.getItem("searchParams");

export const SearchProvider = ({ children }) => {
    const [state, dispatch] = useReducer(reducer, savedState ? JSON.parse(savedState) : initialState);

    return (
        <SearchContext.Provider value={{ state, dispatch }}>
            {children}
        </SearchContext.Provider>
    )
};
